import { ChangeDetectorRef, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { FormArray, FormGroup, UntypedFormGroup } from '@angular/forms';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { MatRadioChange } from '@angular/material/radio';
import { SharedModule } from '@sbd-account-portal/app/shared/shared.module';
import { SharedComponentsModule } from '@sbd-doug-frontend/shared/lib/shared-components/shared-components.module';
import { businessTypes, CIPXQuoteRequestIntakeForm } from '../../../../intake-form.types';
import { isCIPXQuoteRequestIntakeFormStateBond, requiresCredit, sectionHasQuestions } from '../../../../intake-form.helpers';
import { CIPXQuoteRequestIntakeFormService } from '../../../../intake-form.service';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import {
  MatLuxonDateModule,
  MAT_LUXON_DATE_FORMATS,
} from '@angular/material-luxon-adapter';
import { CIPXQuoteRequestIntakeFormQuestionSetComponent } from '../../../../question-set/question-set.component';

@Component({
  standalone: true,
  imports: [
    SharedModule,
    SharedComponentsModule,
    MatLuxonDateModule,
    MatDatepickerModule,
    MatButtonModule,
    MatFormFieldModule,
    MatNativeDateModule,
    MatIconModule,
    CIPXQuoteRequestIntakeFormQuestionSetComponent,
  ],
  providers: [
    MatDatepickerModule,
    {
      provide: MAT_DATE_FORMATS,
      useValue: MAT_LUXON_DATE_FORMATS,
    },
    { provide: MAT_DATE_LOCALE, useValue: 'en-US' },
  ],
  selector: 'cipx-quote-request-intake-form-request-details-bond-information',
  templateUrl: 'bond-information.component.html',
})
export class CIPXQuoteRequestIntakeFormRequestDetailsBondInformationComponent {
  private _intakeFormService = inject(CIPXQuoteRequestIntakeFormService);

  private _changeDetectorRef = inject(ChangeDetectorRef);
  @Input() quoteRequestForm!: FormGroup<CIPXQuoteRequestIntakeForm>;

  sectionHasQuestions = sectionHasQuestions;
  businessTypes = businessTypes;

  selectedStateBond = this._intakeFormService.selectedStateBond;

  ngOnInit() {}

  get requestDetailsGroup(): FormGroup {
    return this.quoteRequestForm.controls.requestDetails;
  }

  get principal(): FormGroup {
    return this.quoteRequestForm.controls.requestDetails.controls.principal as FormGroup;
  }

  get owners(): FormArray {
    return this.quoteRequestForm.controls.requestDetails.controls.owners as FormArray;
  }

  onCompanyNumberOwnersChange(value: MatButtonToggleChange) {
    this._intakeFormService.companyNumberOwnersChanged.emit(value.value);
  }

  onCompanyTypeIdChanged(value: MatRadioChange) {
    if (value.value === 3) {
      this.quoteRequestForm.controls.requestDetails.controls.company_number_owners.setValue(1);
      this._intakeFormService.companyNumberOwnersChanged.emit(1);
    }

    this._intakeFormService.companyTypeIdChanged.emit(value.value);
  }

  setEffectiveDateToday() {
    // Use local date to avoid UTC shift from toISOString() causing past dates in some timezones
    const now = new Date();
    const yyyy = now.getFullYear();
    const mm = String(now.getMonth() + 1).padStart(2, '0');
    const dd = String(now.getDate()).padStart(2, '0');
    const localDate = `${yyyy}-${mm}-${dd}`;
    this.quoteRequestForm.controls.requested_coverage_begin_date.setValue(localDate);
  }

  toggleCompanyAddress() {
    const current = this.quoteRequestForm.controls.requestDetails.controls.addCompanyAddress.value;

    if (current === null || current === false) {
      this.quoteRequestForm.controls.requestDetails.controls.addCompanyAddress.setValue(true);
    } else {
      this.quoteRequestForm.controls.requestDetails.controls.addCompanyAddress.setValue(false);
    }
    this._changeDetectorRef.markForCheck();
  }
}
